export class IncorrectEnvironmentVariableError<
  Value extends any,
> extends Error {
  constructor(
    variableName: string,
    value: Value,
    possibleValues: Value[] | (() => Value[]),
  ) {
    super(
      `The ${variableName} is "${value}", but it can only be one of: ${(typeof possibleValues ===
      'function'
        ? possibleValues()
        : possibleValues
      ).join(', ')}`,
    );
    this.name = 'IncorrectEnvironmentVariableError';
  }
}
